
import "./information.css";

import WidgetLg from "../../components/widgetLg/WidgetLg";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import InfoWidget from "../../components/infoWidget/InfoWidget";

export default function Information() {
  return (
      <div>
    <Topbar />
    <div className="container">

    <Sidebar />
    <div className="home">
      <div className="homeWidgets">
        <InfoWidget/>
      </div>
      
    </div>
    </div>
    </div>
  );
}